import {
  getGetUserRubricGeneratorsQueryKey,
  getGetTopRubricGeneratorsQueryKey,
  likeRubricGenerator,
  unlikeRubricGenerator,
  useDeleteRubricGenerator,
  useGetUserRubricGenerators,
  useGetTopRubricGenerators,
} from "@packages/api/madlenAPI";
import { RubricCard } from "../../components/rubric/RubricCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { RubricGeneratorResponseDto } from "@packages/api/madlenAPI.schemas";

const RubricDetailComponent = ({
  tool,
}: {
  tool: RubricGeneratorResponseDto;
}) => {
  return <RubricCard rubric={tool} isImageLoading={false} />;
};

const RubricView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserRubricGenerators}
      useDeleteTool={useDeleteRubricGenerator}
      getGetToolsQueryKey={getGetUserRubricGeneratorsQueryKey}
      useGetTopTools={useGetTopRubricGenerators}
      likeTool={likeRubricGenerator}
      unlikeTool={unlikeRubricGenerator}
      maxWidth="max-w-6xl"
      getGetTopToolsQueryKey={getGetTopRubricGeneratorsQueryKey}
      toolType="rubric"
      toolPath="rubric"
      DetailComponent={RubricDetailComponent}
      colors={{
        light: "from-[#7EA88E] to-[#4A7759]",
        dark: "dark:from-[#98C4A8] dark:to-[#5E8C6F]",
        iconBg: "bg-[#E8F1EB] dark:bg-[#2A3E33]/30",
        iconColor: "text-[#4A7759] dark:text-[#98C4A8]",
        hover: "hover:bg-[#F4F9F6] dark:hover:bg-[#2A3E33]/15",
      }}
      toolColor="[#4A7759]"
      gradientColor="violet"
    />
  );
};

export default RubricView;
